import React, { useEffect, useState } from 'react'
import { apiEndPoint } from '../../../environment';
import axios from 'axios';

export default function WebpusherIntegrate(props) {
    const [response, setResponse] = useState([])

    const domain = sessionStorage.getItem("siteUrl");

    function trackingCode() {
        let data = JSON.stringify({
            "siteUrl": domain
        });

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${apiEndPoint}setup/tracking`,
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        axios.request(config)
            .then((response) => {
                setResponse(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }
    useEffect(() => {
        trackingCode()
    }, [])

    function copyText() {
        // Get the text field
        var copyText = document.getElementById("install-code");

        // Select the text field
        copyText.select();
        copyText.setSelectionRange(0, 99999); // For mobile devices

        // Copy the text inside the text field
        navigator.clipboard.writeText(copyText.value);

        // Alert the copied text
        document.getElementById('btn-text').innerHTML = "Text Copied."
    }
    return (
        <>
            <div className="page-tracking-code">
                <div className="card mb-3">
                    <div className="bg-holder d-none d-lg-block bg-card" style={{ backgroundImage: 'url(assets/img/illustrations/corner-4.png)' }} />
                    {/*/.bg-holder*/}
                    <div className="card-body">
                        <div className="row">
                            <div className="col-lg-11">
                                <h3 className="mb-0">Step 1: Upload File</h3>
                                <p className="mt-2">Please follow the instructions below to manually integrate Webpushr to your site.</p>
                                <p className="mt-2">Download this file, unzip it and copy it to the root directory of your website. Please do not proceed forward until it is accessible on this link: https://localhost:3000/firebase-messaging-sw.js
                                    Download File </p>
                            </div>
                            <a className='mt-3' href={`${apiEndPoint}setup/tracking/download`} download><button type="button" className="btn btn-primary mr-1 mb-1 download-file-button"> <svg className="svg-inline--fa fa-download fa-w-16" aria-hidden="true" focusable="false" data-prefix="fa" data-icon="download" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg><path fill="currentColor" d="M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z" /></svg>{/* <i class="fa fa-download" aria-hidden="true"></i> */} Download File</button></a>
                        </div>
                    </div>
                </div>
                <div className="card mb-3">
                    <div className="card-header"><h3>Step 2: Add Code</h3></div>
                    <div className="card-body bg-light">
                        <div className="row">
                            <div className="col-lg-12">
                                {/* <h5></h5> */}
                                <p> Copy and paste the javascript snippet below in the header of your site. See our <a rel="noreferrer" target="_blank" href="https://docs.webpushr.com">documentation</a> to learn how.</p>
                                <textarea style={{ height: '170px' }} id="install-code" defaultValue={response.data} />
                                <div onClick={copyText} id='btn-text' className="copyToClipboard f-14 text-primary"><i className="fa fa-file" aria-hidden="true" /> Copy to clipboard</div>
                            </div>
                        </div>{/* row */}
                    </div>
                </div>
            </div>
            <button className="btn btn-primary next-step" onClick={() => props.setActiveStep(2)} >Next  <img src="https://webpushrapp-3744.kxcdn.com/assets/images/next.png" /> </button>
        </>
    )
}
